var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (hasTimeLimit, i18n) {
buf.push("<div class=\"game-state block-h-lg\"><div class=\"game-state-inner row block-v-lg\"><div class=\"game-state-text col-md-6 col-sm-6\">");
if ( hasTimeLimit)
{
buf.push("" + (jade.escape((jade_interp = i18n("game.labels.timer")) == null ? '' : jade_interp)) + "\n&ensp;<strong class=\"game-timer text-lg text-bold\"></strong>");
}
buf.push("</div><div class=\"game-state-text col-md-6 col-sm-6 text-right\">" + (jade.escape((jade_interp = i18n("game.labels.score")) == null ? '' : jade_interp)) + "\n&ensp;<strong class=\"game-score text-lg text-bold\"></strong><strong class=\"game-tally\"></strong></div></div></div>");
if ( hasTimeLimit)
{
buf.push("<div class=\"game-stepper\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div>");
}
if ( hasTimeLimit)
{
buf.push("<div class=\"game-bonus-time\"></div>");
}}.call(this,"hasTimeLimit" in locals_for_with?locals_for_with.hasTimeLimit:typeof hasTimeLimit!=="undefined"?hasTimeLimit:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}